export default __webpack_public_path__ + "static/media/DJ5CTRIAL.20529684.ttf";